import * as Device from "expo-device";
import moment from "moment";
import { enc, MD5 } from "crypto-js";

export interface DeviceInfoProps {
  isDevice: boolean;
  modelName?: string | null;
  modelId?: string | null;
  manufacturer?: string | null; // hsx
  osName?: string | null; // hdhh
  osVersion?: string | null; // osver,
  deviceType?: any;
}

export const getDevicesInfo = (): DeviceInfoProps => {
  const info: DeviceInfoProps = {
    isDevice: Device.isDevice,
    modelName: Device.modelName,
    modelId: Device.modelId,
    manufacturer: Device.manufacturer,
    osName: Device.osName,
    osVersion: Device.osVersion,
  };
  return info;
};

export const createSystemId = async () => {
  const seed = Math.floor(Math.random() * 100) + 1 + moment().valueOf().toString();
  const modelId = Device.modelId;
  const modelName = Device.modelName;
  const systemIdTmp = (modelId + modelName + seed).toString().replace(" ", "");
  return await MD5(systemIdTmp).toString(enc.Hex);
};

export const getDeviceType = async () => {
  const deviceType = await Device.getDeviceTypeAsync();
  const type = Device.DeviceType[deviceType];
  console.log("type: ", type);
  return type;
};
